import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { storage } from '../../firebase'
import AdminSuccess from './AdminSuccess'
import Loading from '../common/Loading'

const Modal = styled.div`

  .image-upload-preview {
    max-width: 15em;
  }

  .loading-component {
    margin: 1em auto;
  }
`

export default class AdminImageUploadModal extends React.Component {
  constructor () {
    super()
    this.state = {
      file: null,
      imagePreviewUrl: null,
      success: false,
      uploading: false,
    }
    this.handleImageChange = this.handleImageChange.bind(this)
    this.cancelUpload = this.cancelUpload.bind(this)
    this.handleUpload = this.handleUpload.bind(this)
    this.showSuccessModal = this.showSuccessModal.bind(this)
    this.currentUpload = null
  }

  handleImageChange (e) {
    e.preventDefault()
    const file = e.target.files[0]

    if (typeof file === 'undefined' && this.state.file !== null) return

    if (!file.type.match('image.*')) {
      return alert('Please choose a jpg, gif, png or bmp file.')
    }

    const reader = new FileReader()
    reader.onloadend = () => {
      this.setState({ file, imagePreviewUrl: reader.result })
    }
    reader.readAsDataURL(file)
  }

  handleUpload (e) {
    e.preventDefault()
    const { file } = this.state
    if (!file) {
      return alert('Please choose a file.')
    }
    const { alt } = this.props
    const filename = `${alt.replace(/\s+/g, '-')}-${Date.now()}.${file.name.split('.').pop()}`
    const ref = storage.ref().child(`images/${this.props.param}/${filename}`)
    const metadata = { contentType: file.type }
    this.setState({ uploading: true })
    this.currentUpload = ref.put(file, metadata)
    this.currentUpload.then(snapshot => {
      this.props.updateImageData(snapshot.downloadURL, alt, this.showSuccessModal)
    }).catch(error => {
      console.log(error)
      alert("Oops. That didn't work...")
    })
  }

  showSuccessModal (cb) {
    this.setState({
      success: true,
      uploading: false,
    }, () => setTimeout(cb, 1000))
  }

  cancelUpload () {
    this.image.value = ''
    if (this.currentUpload !== null) this.currentUpload.cancel()
    this.setState({
      imagePreviewUrl: null,
      file: null,
    }, this.props.toggleImageModal)
  }

  render () {
    const { className, handleFormChange, alt } = this.props
    const { imagePreviewUrl, success, uploading } = this.state
    return (
      <Modal className={className}>
        <div className="modal-background" />
        <div className="modal-content">
          <div className="box is-block">
            <div className="content">
              <h5 className="title is-5">Image Upload</h5>
              <div className="file">
                <label className="file-label">
                  <input
                    ref={el => this.image = el}
                    className="file-input"
                    type="file"
                    name="resume"
                    onChange={this.handleImageChange}
                    required />
                  <span className="file-cta">
                    <span className="file-icon">
                      <i className="fa fa-upload" />
                    </span>
                    <span className="file-label">
                      Choose a file…
                    </span>
                  </span>
                </label>
              </div>
            </div>
            { imagePreviewUrl &&
              <div className="content image-upload-preview">
                <img src={imagePreviewUrl} alt={alt} />
              </div> }
            <div className="content">
              <h5 className="title is-5">Short Description</h5>
              <div className="field">
                <div className="control">
                  <input className="input coverimagealt-input"
                    type="text"
                    value={alt}
                    name="imageAlt"
                    onChange={handleFormChange} />
                </div>
              </div>
            </div>
            { uploading && <Loading color="#ff486a" /> }
            <div className="field">
              <div className="control">
                <button className="button is-info" onClick={this.handleUpload}>
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
        <button className="modal-close is-large" aria-label="close" onClick={this.cancelUpload} />
        <AdminSuccess
          type="Upload"
          className={success ? 'modal is-active' : 'modal'} />
      </Modal>
    )
  }
}

AdminImageUploadModal.propTypes = {
  className: PropTypes.string.isRequired,
  handleFormChange: PropTypes.func.isRequired,
  alt: PropTypes.string,
  toggleImageModal: PropTypes.func.isRequired,
  param: PropTypes.string.isRequired,
  updateImageData: PropTypes.func,
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminImageUploadModal.js